import { render, staticRenderFns } from "./privacy-policy.vue?vue&type=template&id=7d715d8b&scoped=true"
var script = {}
import style0 from "./privacy-policy.vue?vue&type=style&index=0&id=7d715d8b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d715d8b",
  null
  
)

export default component.exports